import styled from 'styled-components';
import { GlobalColors, GlobalFonts } from '../../globals';

export const ContCoreBancarioPage = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (min-width: 300px) and (max-width: 767px) {
    padding-top: 70px !important;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    padding-top: 120px !important;
  }
  @media (min-width: 1024px) and (max-width: 1079px) {
    padding-top: 27px !important;
  }
  @media (min-width: 1080px) and (max-width: 1279px) {
    padding-top: 110px !important;
  }
  @media (min-width: 1280px) and (max-width: 1407px) {
    padding-top: 120px !important;
  }
  @media (min-width: 1408px) and (max-width: 1439px) {
    padding-top: 130px !important;
  }
  @media (min-width: 1440px) and (max-width: 1919px) {
    padding-top: 130px !important;
  }
  @media (min-width: 1440px) and (max-width: 1639px) {
    padding-top: 130px !important;
  }
  @media (min-width: 1640px) and (max-width: 1919px) {
    padding-top: 130px !important;
  }
  @media (min-width: 1920px) {
    padding-top: 150px !important;
  }
`;

export const ContHeroCoreBancario = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 70px;
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 300px) and (max-width: 767px) {
    width: 90%;
    align-items: center;
    justify-content: center;
  }

`;

export const TitleWrapper = styled.div`
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DescCoreBancario = styled.div`
  width: 60%;
  margin-bottom: 40px;
  font-family: ${GlobalFonts.fontRegular};
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: ${GlobalColors.colorText};

  z-index: 1;

  & > span {
    font-family: ${GlobalFonts.fontBold};
  }

  @media (min-width: 300px) and (max-width: 767px) {
    width: 100%;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    width: 100%;
    font-size: 20px;
    line-height: 28px;
  }
  @media (min-width: 1024px) and (max-width: 1079px) {
    width: 70%;
  }
  @media (min-width: 1080px) and (max-width: 1279px) {
    width: 70%;
  }
  @media (min-width: 1280px) and (max-width: 1407px) {
    width: 70%;
  }
  @media (min-width: 1408px) and (max-width: 1439px) {
    width: 60%;
  }
  @media (min-width: 1440px) and (max-width: 1919px) {
    width: 60%;
  }
  @media (min-width: 1920px) {
    width: 60%;
  }
`;

export const ContButton = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 300px) and (max-width: 767px) {
  }
  @media (min-width: 768px) and (max-width: 1023px) {
  }
  @media (min-width: 1024px) and (max-width: 1079px) {
  }
  @media (min-width: 1080px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) and (max-width: 1407px) {
  }
  @media (min-width: 1408px) and (max-width: 1439px) {
  }
  @media (min-width: 1440px) and (max-width: 1919px) {
  }
  @media (min-width: 1920px) {
  }
`;

export const ContImg = styled.div`
  width: 100%;
  margin: 40px 0 60px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 300px) and (max-width: 767px) {
    margin: 20px 0 40px 0;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    margin: 30px 0 50px 0;
  }
`;
